import { Component, OnInit, ViewChild, OnDestroy, ViewContainerRef, Output, EventEmitter, OnChanges, Input } from '@angular/core';
import {DemoService} from '../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

// ag- table component

import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
// import { CustomiszedCellComponent } from '../customiszed-cell/customiszed-cell.component';
// import { CustomCellJobTypeComponent } from '../custom-cell-job-type/custom-cell-job-type.component';
// import { CustomCellJobLinkComponent } from '../custom-cell-job-link/custom-cell-job-link.component';
// import { CustomCellDateComponent } from '../custom-cell-date/custom-cell-date.component';

// 

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter, PdfExportService, PageService, SearchSettingsModel, RowSelectEventArgs } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs, FilterType } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { delay } from 'rxjs';

import { FilterService, IFilterUI, Column, DateFilterUI } from '@syncfusion/ej2-angular-grids';
import { DatePicker, DateRangePicker } from '@syncfusion/ej2-calendars';
import { EditService, SortService,  SelectionSettingsModel } from '@syncfusion/ej2-angular-grids';
import { DataUtil } from '@syncfusion/ej2-data'; 
import { ButtonComponent } from '@syncfusion/ej2-angular-buttons';


import { parentsUntil } from '@syncfusion/ej2-grids';
import { pipe, Observable, Subject, map } from 'rxjs';
import { MysqlService } from './../../services/mysql.service';

// import {JobsAgentUpdateRequestComponent} from './../../ jobs-agent-update-request/jobs-agent-update-request.component';
import { GlobalFunctionsService } from './../../services/global-functions.service';
import { LegalDateTimeService } from './../../services/legal-datetime.service';
import { SearchContact } from 'src/app/shared/models/searchContact.model';
import { JobSubject } from 'src/app/shared/models/jobSubject.model';

@Component({
  selector: 'app-client-jobs-urgent-timeframes',
  templateUrl: './client-jobs-urgent-timeframes.component.html',
  styleUrls: ['./client-jobs-urgent-timeframes.component.scss']
})
export class ClientJobsUrgentTimeframesComponent implements OnInit {


// added to be included as a component as well
@Input() item_id?; // impliments on changes.
@Input() item_data?; // if data.model is sent : Observable<any[]>;
@Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
@Input() item_user_level_id? = '5'; // default to agent just in case
@Input() item_brand_type_id? = '';
@Input() show_buttons? = 'no'; // yes | no
@Input() widget_title? = '';
@Input() widget_size? = 'full'; // side | abstract | full


  job_table: any;
  result: any;
  client_name: any;
  persons: any;
  job_table2: any;
  client_name_value: any;
 responseDelay = 2000;
  clients: any;
  clientLocalRecord: any;
  job_types: any;
  subjects: any;
  agents_assigned: any;
  staffList: any;
  items: Object[];
  data_subjects2: any;
  initialPage: PageSettingsModel;

  jobTypesLocalRecord: any;
  changeObject: any;

  subjectLocalRecord: any;

  createdAt: any;
  nextDateLocalRecord: any;

  agentsAssignedLocalRecord: any;
  allocated_agents_list: any;

  public data: DataManager;
  public data_subjects: DataManager;
  public pageSettings: Object;
  public pageOptions = { pageSize: 100 }; 
  public filterOptions: FilterSettingsModel;
  public filterOptions_2022: FilterSettingsModel;
  public formatOptions: Object;
  // public filterOptions: FilterSettingsModel;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[] | object;
  @ViewChild('grid')
  public grid: GridComponent;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;

  job_table3: any; // filtered results of job table2 to load properly
  brands: any;
  brandsLocalRecord: any;
  brandLocalRecord: any;
  subject_agents_assigned: any;
  subjectsAssignedLocalRecord: any;
  allocated_agents_subject_list: any;
  brandAgentsList: any;
  assignedBrandList: any;
  public toolbar: ToolbarItems[] | object;

  search_results: any;
  search_results_processed: Array<{subject_id: number, email_sent: string}> = [];



  filterSettings: Object;
  public templateOptions: IFilter;
  public dateRangePicker: DateRangePicker;


// Evemt Emmitter to child Component
  eventsSubject: Subject<void> = new Subject<void>();
  search_resultsO: any;
  subject_sent: any;
  currentUserVAR: any;
  sessionUserId: any;
  sessionBrandId: any;
  brand_id: any;
  subject_id: any;
  get_latest_subject_note_id: Object;
  sessionUserUserName: any;
  sr: any;
  subjects_urgent: any;
  formatoptions: { type: string; format: string; };
  dateFormat: string;

  today = new Date();

  sessionUsername: any;
  all_router_details: string;
  subjects_urgent_table: any;
  assignedAgentsList: any;
  allRecipients: any;
  assigned_to_agents: string;
  user_levels: Object;
  brand_types: Object;
  brand_user_join_results: any[];
  brand_search: Object;
  brand_search_results: any;
  user_search: Object;
  user_search_results: any;
  users: Object;
  usersPrimary: Object;
  todaySetFormat: any;
  rule_text_OPEN: string;
  rule_email_text_OPEN: any;
  rule_text_UPDREQ: string;
  rule_email_text_UPDREQ: string;
  selectedrecords: Object[];
  rule_text_UPDSENT: string;
  rule_email_text_UPDSENT: string;
  rule_text_AOA: string;
  rule_email_text_AOA: string;

  // target the submit button to auto submit the form

  emitEventToChild() {
    this.eventsSubject = this.search_results;
    this.eventsSubject.next();

    this.search_resultsO = this.search_results;
  }

  public searchOptions: SearchSettingsModel;

  // custom search
  // search_model: SearchContact;
  search_model: JobSubject;


  constructor(
    private http: HttpClient, private router: Router, route: ActivatedRoute, private _demoService: DemoService,
    public datepipe: DatePipe,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private _mysqlService: MysqlService, 
    public gfunc: GlobalFunctionsService,
    public legalDate: LegalDateTimeService
  ) {

    // yyyy-MM-dd
    this.todaySetFormat = this.legalDate.format(new Date(), 'DD/MM/YYYY');
    
//    this.mapJobTableLive(); // load the table data
// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

this.rule_text_OPEN = 'If subject status OPEN, and final date null or not yet set, Status will be changed to UPDREQ and filinal date and next changed to now. If final date is less then the date and time now the next date will be set to the final date and final date remains. if the final date is greater than now the next date becomes now and the final date remains. '; // this will be the content for the actual rule for what happens so I can output to screens and test.
this.rule_email_text_OPEN = 'Agent will recieve First Email - Please provide an update in relation to the above named matter';

this.rule_text_UPDREQ = 'If subject status UPDREQ, and final date null or not yet set it to now, Status will be NOT be changed. If the final date is less than now set next date to now. Else the next date will stay unchanged. '; // this will be the content for the actual rule for what happens so I can output to screens and test.
this.rule_email_text_UPDREQ = 'Agent will recieve Update Email - We refer to our previous update request and now request an urgent update in relation to the above matter.';

this.rule_text_UPDSENT = 'If subject status UPDSENT, and final date null or not yet set it to now, final date unchanged. Status will be changed to UPDREQ. If the final date is less than now set next date to now. Else the next date will stay unchanged. '; // this will be the content for the actual rule for what happens so I can output to screens and test.
this.rule_email_text_UPDSENT = 'Agent will recieve Update Email - Please provide an update in relation to the above named matter.';

this.rule_text_AOA = 'If subject status UPDSENT, and final date null or not yet set it to now, final date unchanged, next date will be now. Status will be NOT be changed. If the final date is less than now set next date to the final date. '; // this will be the content for the actual rule for what happens so I can output to screens and test.
this.rule_email_text_AOA = 'Agent will recieve Update Email - We are yet to recieve a swarn Affidavit of Attempt of Service in this matter. Please advise as soon as possible....';




// // login vars
// this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser'));
// // Set loggind in User Value (USER ID)
// this.sessionUserId = this.currentUserVAR.user_id;
// this.sessionUserUserName = this.currentUserVAR.username;
// this.sessionBrandId = this.currentUserVAR.brand_id;
this.brand_id = this.sessionBrandId;
// this.toastr.setRootViewContainerRef(vcr);


   }

  private normalizeLegalSearchModel(search_model: any): any {
    const normalized = { ...search_model };

    normalized.next_date_from = this.legalDate.toStartOfDayIso(search_model?.next_date_from);
    normalized.next_date_to = this.legalDate.toEndOfDayIso(search_model?.next_date_to);
    normalized.final_date_from = this.legalDate.toStartOfDayIso(search_model?.final_date_from);
    normalized.final_date_to = this.legalDate.toEndOfDayIso(search_model?.final_date_to);
    normalized.hearing_date_from = this.legalDate.toStartOfDayIso(search_model?.hearing_date_from);
    normalized.hearing_date_to = this.legalDate.toEndOfDayIso(search_model?.hearing_date_to);

    return normalized;
  }


  // check for changes. to load data.
  ngOnChanges(changes) {

   

    if (changes.item_id) {

// ... custom search
this.search_model = new JobSubject();
// this.search_model = new SearchContact();
this.getFormUserLevels();
this.getBrandBrandTypes();


      this.getJobSubjectsUrgentTimeframeTableClient(this.brand_id);
      this.refreshGrid();
      
      // deal with asynchronous Observable result
      // this.job_id = changes.item_id.currentValue;
      // this.getJob(this.job_id);
    }
  }


  ngOnInit() {

// ... custom search
this.search_model = new JobSubject();
// this.search_model = new SearchContact();
this.getFormUserLevels();
this.getBrandBrandTypes();



   // this.toastr.info('Urgent Jobs Processor');
  //  this.getJobSubjectsUrgentTableClient(this.brand_id);
  this.getJobSubjectsUrgentTimeframeTableClient(this.brand_id)
    
  
  //   this.toolbarOptions = ['ExcelExport', 'Search', { text: ' >: Filter Agents For Update Request',
  //    tooltipText: 'Submit Data to Send Agent Notifications', prefixIcon: 'e-test', id: 'Click'  }
  // ];

  this.toolbarOptions = ['Search'];

   // this.toolbar = [
   // { text: 'Agent Update Request', tooltipText: 'Click', prefixIcon: 'e-expand', id: 'Click' }];

  this.initialPage = { pageSize:10 };
  // FilterBar, Menu, Excel Checkbox
   this.filterOptions = {
      type: 'Menu'
   };

  // FilterBar, Menu, Excel Checkbox
  this.filterOptions_2022 = {
    type: 'Menu'
 };
  this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
  // this.formatoptions = {};
   this.dateFormat = '';
   this.filter = {  };

  // this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
  //  this.formatoptions = {type:'date', format:'dd/MM/yyyy'};
  //  this.dateFormat = 'dd/MM/yyyy hh:mm a';
  //  this.filter = { params: { format: this.dateFormat } };





// :: To fix the issue of nothing loading from the jobs screen to urngent
// end date filter options
// This function is very important and now pauses then load the document correctly.
setTimeout(() => {  
  console.log("A Simple Pause!"); 
  this.refreshGrid();
  console.log("Now Ready to load...");
}, 2000);





  }




agentUpdateRequest(search_results) {
  console.log(search_results);
  // loop through each request to action 

this.sr = search_results;

  // for (let i = 0; i < search_results.length; i++) {
  //   this.sendAgentUpdateEmail(search_results.subject_id[i], search_results.job_status[i]);
 // }

console.log(this.sr.length);


for (let i = 0; i < this.sr.length; i++) {
      // add assigned_to_agents array! (Gets Currnt Assigned agents)
      // testing did not work
            // this.getSubjectAgentBrandsAssigned2(this.sr[i].subject_id);
            // this.assigned_to_agents = JSON.stringify(this.allRecipients);
            // console.log('result.assigned_to_agents: ', this.assigned_to_agents);
}



  (async () => {
let i = 0;
  for(let result of this.sr){

    console.log(result.job_id);
    console.log('Subject_ID', result.subject_id);
   // on success notify.

   console.log(result); // grabs the entire row in to a var
  
    // we need three functions

   this.sendAgentUpdateEmail(result);
   this.updateSubjectAgentStatus(result.subject_id, result.job_status, result);

   this.getSubjectAgentBrandsAssigned2(result.subject_id, result); // set here so variables are already loaded to add the note updates
  //  this.createSubjectNote(result);

 // then maybe push to a sent array on page to show success of each record.??

   this.toastr.success('We have updated: ' + result.subject_number);
   await this.delay(700);
 //  i++;
 
 
 }

// this.refreshGrid(); // stop the refresh now that we have check boxes this make the items dissapear and uncheck after process... so do not turn on. feb 2023

})(); // end async function

};



// delay function
 delay(ms: number) {
  return new Promise( resolve => setTimeout(resolve, ms) );
}



sendAgentUpdateEmail(result) {
 
 console.log(result.job_status);



  if (result.job_status === 'OPEN'){
  this._mysqlService.sendAgentUpdateEmail(result.subject_id, result);
    this.toastr.info('Email Notification Sent');  
    // push to search_results array email_sent
    // https://stackoverflow.com/questions/4689856/how-to-change-value-of-object-which-is-inside-an-array-using-javascript-or-jquer/50504081
    const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
    this.search_results[objIndex].email_sent = 'yes';
    // the above works!!
    // this was setup so that I could have another included component that pushed information accross.
this.subject_sent = result.subject_id;
    // testing push to another array
  //  this.search_results_processed.push({subject_id: this.subject_sent, email_sent: 'YES'});
  }// end if open


  if (result.job_status === 'UPDREQ'){
    this._mysqlService.sendAgentUpdateEmail(result.subject_id, result);
      this.toastr.info('Email Notification Sent');  
      // push to search_results array email_sent
   
      const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
      this.search_results[objIndex].email_sent = 'yes';
      // the above works!!
      // this was setup so that I could have another included component that pushed information accross.
  this.subject_sent = result.subject_id;
      // testing push to another array
     // this.search_results_processed.push({subject_id: this.subject_sent, email_sent: 'YES'});
    }// end if updreq


   
    if (result.job_status === 'UPDSENT'){
      this._mysqlService.sendAgentUpdateEmail(result.subject_id, result);
        this.toastr.info('Email Notification Sent');  
        // push to search_results array email_sent
     
        const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
        this.search_results[objIndex].email_sent = 'yes';
        // the above works!!
        // this was setup so that I could have another included component that pushed information accross.
    this.subject_sent = result.subject_id;
        // testing push to another array
       // this.search_results_processed.push({subject_id: this.subject_sent, email_sent: 'YES'});
      }// end if


      if (result.job_status === 'AOS'){
        this._mysqlService.sendAgentUpdateEmail(result.subject_id, result);
          this.toastr.info('Email Notification Sent');  
          // push to search_results array email_sent
       
          const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
          this.search_results[objIndex].email_sent = 'yes';
          // the above works!!
          // this was setup so that I could have another included component that pushed information accross.
      this.subject_sent = result.subject_id;
          // testing push to another array
         // this.search_results_processed.push({subject_id: this.subject_sent, email_sent: 'YES'});
        }// end if


        
      if (result.job_status === 'AOA'){
        this._mysqlService.sendAgentUpdateEmail(result.subject_id, result);
          this.toastr.info('Email Notification Sent');  
          // push to search_results array email_sent
       
          const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
          this.search_results[objIndex].email_sent = 'yes';
          // the above works!!
          // this was setup so that I could have another included component that pushed information accross.
      this.subject_sent = result.subject_id;
          // testing push to another array
         // this.search_results_processed.push({subject_id: this.subject_sent, email_sent: 'YES'});
        }// end if





  };

  updateSubjectAgentStatus(subject_id, job_status, result){

// Esure of test first rule as I - put and override on the next date on open as it was reverting back to 1979 -- text and fix!

// as options in the upate request. 
// send emails
// changes status and dates per rules.
// Add simple check box so that can add items by simply checking withoug filter.
// Make warning and clear that dates will be updated,status changes as well as contents of the email being sent in a preview.


    if (job_status === 'OPEN'){
      // need to update status codes and dates
        const new_status = 'UPDREQ';



      this._demoService.updateSubjectStatusBulk(result, new_status).subscribe(
        data => { // this.trace_candidate_update = data;
        this.toastr.success('Subject Status Updated');
        const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
        this.search_results[objIndex].updated_status = 'yes';
        },
        error => {
          this.toastr.error('Error Changing Status of Subject');
         return console.log(error);
        }
    );
    } // end if open



    if (job_status === 'UPDREQ'){
      // need to update status codes and dates
        const new_status = 'UPDREQ'; // leave as same status

      this._demoService.updateSubjectStatusBulk(result, new_status).subscribe(
        data => { // this.trace_candidate_update = data;
        this.toastr.success('Subject dates Changed');
        const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
        this.search_results[objIndex].updated_status = 'yes';
        },
        error => {
          this.toastr.error('Error Changing Status of Subject');
         return console.log(error);
        }
    );
    } // end if 


    if (job_status === 'UPDSENT'){
      // need to update status codes and dates
        const new_status = 'UPDREQ'; // leave as same status

      this._demoService.updateSubjectStatusBulk(result, new_status).subscribe(
        data => { // this.trace_candidate_update = data;
        this.toastr.success('Subject dates Changed');
        const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
        this.search_results[objIndex].updated_status = 'yes';
        },
        error => {
          this.toastr.error('Error Changing Status of Subject');
         return console.log(error);
        }
    );
    } // end if 


    if (job_status === 'AOS'){
      // need to update status codes and dates
        const new_status = 'AOS'; // leave as same status

      this._demoService.updateSubjectStatusBulk(result, new_status).subscribe(
        data => { // this.trace_candidate_update = data;
        this.toastr.success('Subject dates Changed');
        const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
        this.search_results[objIndex].updated_status = 'yes';
        },
        error => {
          this.toastr.error('Error Changing Status of Subject');
         return console.log(error);
        }
    );
    } // end if 

    
    if (job_status === 'AOA'){
      // need to update status codes and dates
        const new_status = 'AOA'; // leave as same status

      this._demoService.updateSubjectStatusBulk(result, new_status).subscribe(
        data => { // this.trace_candidate_update = data;
        this.toastr.success('Subject dates Changed');
        const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
        this.search_results[objIndex].updated_status = 'yes';
        },
        error => {
          this.toastr.error('Error Changing Status of Subject');
         return console.log(error);
        }
    );
    } // end if 


  }


// need to get all associated agents of the job and push thier information to array
getSubjectAgentBrandsAssigned2(subject_id, result) {
  this.allRecipients = [];
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
     data => { 
       this.assignedAgentsList = data;

       let newArr = data;
       let  count_of_items = Object.keys(newArr).length;
         // need to do a loop of subject_billing items (.length)
         for(let i=0;i < count_of_items; i++) {
         let res = newArr[i];
         this.allRecipients.push({
           recipient_name: res.name + '',
           recipient_email_address: res.email,
           recipient_brand_id: res.brand_id,
           recipient_subject_id: res.subject_id,
           recipient_brand_type_id: res.brand_type_id,
           recipient_user_id: null,
           recipient_user_level_id: null,
           recipient_type_name: 'Agent',
         });
         } // end for loop
       this.allRecipients = this.allRecipients; // ?? this may be causing errors.
       // set records to send to subject_notes data table
      //  this.model.assigned_to_agents = JSON.stringify(this.allRecipients);
      console.log('AllRecipients: ', JSON.stringify(this.allRecipients));

      // now insert the note as it would not load the recipeints outside function
   this.createSubjectNote(result);

    },
     err => console.error(err),
     // () => console.log('Loaded Assigned Agents Loaded.')
   );
 }






  createSubjectNote(result) {


    // this.getSubjectAgentBrandsAssigned2(result.subject_id); // set here so variables are already loaded to add the note updates

   // this.sendEmail(this.job_id, this.subject_id, this.sessionUserId, model);
   result.created_by = this.sessionUserId;
   result.note_content = 'First updated request emailed to the agent. Automated from Batch Urgent Jobs Screen.';
  
   result.brand_type_id = 3; // Agent
   result.note_type_id = 6; // bactch process
   result.user_level_id = 5;   // agent
   result.subject_com_type_id = 0; // empty string
   result.doc_id = 0;
   result.assigned_to_agents = JSON.stringify(this.allRecipients);
   console.log('AllRecipients AFTER: ', JSON.stringify(this.allRecipients));


   if (result.job_status === 'OPEN'){
    this._demoService.createSubjectNote(result).subscribe(
         data => {  this.get_latest_subject_note_id = data; // this is the retuned json upon creation.
          this.toastr.info('Note Added To Subject!');
          const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
          this.search_results[objIndex].note_added = 'yes';
         },
         error => {
           // console.log(Observable.throw(error));
           //return console.log(error);
         }
    );
  } // end if  open


  if (result.job_status === 'UPDREQ'){
    result.note_content = 'Second and urgent update request emailed to agent. Automated from Batch Urgent Jobs Screen.';
    this._demoService.createSubjectNote(result).subscribe(
         data => {  this.get_latest_subject_note_id = data; // this is the retuned json upon creation.
          this.toastr.info('Note Added To Subject!');
          const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
          this.search_results[objIndex].note_added = 'yes';
          this.search_results[objIndex].x = 'yes';
         },
         error => {
          //  console.log(Observable.throw(error));
          // return console.log(error);
         }
    );
  } // end if  UPDREQ


  if (result.job_status === 'UPDSENT'){
    result.note_content = 'Further update request emailed to agent. Automated from Batch Urgent Jobs Screen.';
    this._demoService.createSubjectNote(result).subscribe(
         data => {  this.get_latest_subject_note_id = data; // this is the retuned json upon creation.
          this.toastr.info('Note Added To Subject!');
          const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
          this.search_results[objIndex].note_added = 'yes';
         },
         error => {
           // console.log(Observable.throw(error));
           //return console.log(error);
         }
    );
  } // end if  UPDREQ


  if (result.job_status === 'AOS'){
    result.note_content = 'Update request emailed to agent regarding the return of the Affidavit of Service. Automated from Batch Urgent Jobs Screen.';
    this._demoService.createSubjectNote(result).subscribe(
         data => {  this.get_latest_subject_note_id = data; // this is the retuned json upon creation.
          this.toastr.info('Note Added To Subject!');
          const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
          this.search_results[objIndex].note_added = 'yes';
         },
         error => {
           // console.log(Observable.throw(error));
           //return console.log(error);
         }
    );
  } // end if 


  if (result.job_status === 'AOA'){
    result.note_content = 'Update request emailed to agent regarding the return of the Affidavit of Attempted Service. Automated from Batch Urgent Jobs Screen.';
    this._demoService.createSubjectNote(result).subscribe(
         data => {  this.get_latest_subject_note_id = data; // this is the retuned json upon creation.
          this.toastr.info('Note Added To Subject!');
          const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
          this.search_results[objIndex].note_added = 'yes';
         },
         error => {
           // console.log(Observable.throw(error));
           //return console.log(error);
         }
    );
  } // end if  UPDREQ



    }




  // https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
  clickHandler(args: ClickEventArgs): void {
    if (args.item.id === 'Click') {

    //  this.grid.showSpinner();

    //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
   //  console.log(args.data.items);
   


    let pdfdata;
    const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
    for (let i = 0; i < query.queries.length; i++) {
      if (query.queries[i].fn === 'onPage') {
        query.queries.splice(i, 1);       // remove page query to get all records
        break;
      }
    }
    const fdata = new DataManager({ json: this.subjects_urgent }).executeQuery(query).then((e: any) => {
      pdfdata = e.result as object[];  // get all filtered records
      const exportProperties = {
        dataSource: pdfdata,
      };
      //console.log(pdfdata.results);
      
     // this.search_results = pdfdata.records; // need this if a grouping is set.
      this.search_results = pdfdata;
      this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
      this.toastr.success( "Press Start To Process Que"); 
     // this.grid.pdfExport(exportProperties);
    }).catch((e) => true);
    }

   //  this.grid.hideSpinner();

}


// New way of rendering table data
mapJobTableLive() {

  (async () => {
  this.getClients(); // load clients first
  this.getJobTypes();
  this.getJobSubjectsAll();
  this.getBrandUsers('94'); // for sharmans only
  this.getJobAgentsAllAssigned();
  this.getBrands(); //
  this.getJobAgentsAllAssigned();
  this.getSubjectAgentsAssignedAll();
  await this.delay(3000);
 })(); // end async function  

  this.http.get<any>(this.gfunc.apiURL + '/api/job/table/all/urgent')
 .pipe(map(data => {
  // do your transformations
  this.job_table2 = data;
 
  this.job_table2.forEach(element => {

// local Client Name
/*
this.clientLocalRecord = this.clients.filter(c => c.client_id === element.client_id);
let rs = this.clientLocalRecord;
this.changeObject = Object.assign(this.clientLocalRecord);
element.client_id  = this.changeObject[0].name;
*/
// get brand_report_id // client brand Name

this.brandLocalRecord = this.brands.filter(c => c.brand_id === element.brand_report_id);
this.changeObject = Object.assign(this.brandLocalRecord);
element.brand_report_id  = this.changeObject[0].name;


// Get Job Types
this.jobTypesLocalRecord = this.job_types.filter(c => c.job_type_id === element.job_type_id);
this.changeObject = Object.assign(this.jobTypesLocalRecord);
element.job_type_id  = this.changeObject[0].job_type_name;
// Get Job Subject Name
this.subjectLocalRecord = this.subjects.filter(c => c.subject_id === element.subject_id);
this.changeObject = Object.assign(this.subjectLocalRecord);
if (this.changeObject[0].first_name === null){
 // element.subject_id = '-';
  element.subject_name = '-';
}else{
 // element.subject_id  = this.changeObject[0].first_name + ' ' + this.changeObject[0].surname;
element.subject_name = this.changeObject[0].first_name + ' ' + this.changeObject[0].surname;
}

this.setLegalGridDateFields(element);
// Agents Assigned
// this.agentsAssignedLocalRecord = this.agents_assigned.filter(c => c.job_id === element.job_id); // old version
this.agentsAssignedLocalRecord = this.agents_assigned.filter(c => c.subject_id === element.subject_id);
this.changeObject = Object.assign(this.agentsAssignedLocalRecord);
let recordCount = this.changeObject.length;
console.log(recordCount);
this.allocated_agents_list = '';
if (recordCount < 1){
  this.allocated_agents_list = '-';
}else{
  for (let i = 0; i < recordCount; i++) {
// this.allocated_agents_list  += this.changeObject[i].first_name + ' ' + this.changeObject[i].surname + ', ';
this.allocated_agents_list  += this.changeObject[i].name + ', ';
} // end loop
}
element.allocated_to  = this.allocated_agents_list;



}); // end for each of all


return this.job_table2;

})
) // end pipe.map

  .subscribe(results => this.job_table2 = results
  );



}




// get the mapping stuff

getClients() {
  this._demoService.getClients().subscribe(
     data => { this.clients = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

// need to get new clients
getBrands() {
  this._demoService.getBrands().subscribe(
     data => { this.brands = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 getJobTypes() {
  this._demoService.getJobTypes().subscribe(
     data => { this.job_types = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getJobSubjectsAll() {
  this._demoService.getJobSubjectsAll().subscribe(
     data => { this.subjects = data;
      let res = data[0];
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getJobAgentsAllAssigned() {
  this._demoService.getSubjectBrandAgentsAssignedAll().subscribe(
     data => { this.agents_assigned = data;
      let res = data[0];
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 

 getSubjectAgentsAssignedAll(){
  this._demoService.getSubjectAgentsAssignedAll().subscribe(
    data => { this.subject_agents_assigned = data;
     let res = data[0];
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
 }


  // need to get brand agents.
  getBrandAgents() {
    this._demoService.getBrandAgents().subscribe(
       data => { this.brandAgentsList = data;
      },
       err => console.error(err),
       // () => console.log('Agent Brands Loaded.')
     );
   }



   getSubjectAgentBrandsAssigned(subject_id) {
    this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
       data => { this.assignedBrandList = data;
      },
       err => console.error(err),
       // () => console.log('Loaded Assigned Agents Loaded.')
     );
   }


// gets the list of users assiciated for drop down.
getBrandUsers(brand_id) {
  this._demoService.getBrandUsers(brand_id).subscribe(
     data => { this.staffList = data;
    },
     err => console.error(err),
     () => console.log('Candidates Loaded.')
   );
 }




 toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}



jobLink(job_id) {
  this.router.navigate(['/admin/jobs/create-job-3/' + job_id + '']);
}

jobView(job_id) {
  this.router.navigate(['/admin/jobs/view/' + job_id + '']);
}

subjectEdit(subject_id){
  this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']);
}


refreshGrid(){ // refresh the databutton
 // this.mapJobTableLive();
// this.getJobSubjectsUrgentTable();
// this.getJobSubjectsUrgentTableClient(this.brand_id);
this.getJobSubjectsUrgentTimeframeTableClient(this.brand_id)
  this.grid.refresh();
};



getJobSubjectsUrgentTableClient(brand_id) {
  this._demoService.getJobSubjectsUrgentTableClient(brand_id).subscribe(
    data => { this.subjects_urgent = data;
      let subjects_urgent_top_10 = this.subjects_urgent.slice(0, 10);
      this.subjects_urgent_table = this.subjects_urgent.slice(0, 10);
      // pass so that the dates are correct in Sync
      // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
      this.subjects_urgent = this.applyLegalGridDateFields(DataUtil.parse.parseJson(data)); 
      this.subjects_urgent_table = this.subjects_urgent.slice(0, 10);
     // console.log("Done loadng USER");
     // console.log(this.users);


    },
    error => {
    //  console.error('Error Loading User!');
    console.log(error);
    }
  ); }


// what does this do it counts maybe?
  counter(i: number) {
    return new Array(i);
}



getJobSubjectsUrgentTimeframeTableClient(brand_id) {
  this._demoService.getJobSubjectsUrgentTimeframeTableClient(brand_id).subscribe(
    data => { this.subjects_urgent = data;
      let subjects_urgent_top_10 = this.subjects_urgent.slice(0, 10);
      this.subjects_urgent_table = this.subjects_urgent.slice(0, 10);
      // pass so that the dates are correct in Sync
      // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
      this.subjects_urgent = this.applyLegalGridDateFields(DataUtil.parse.parseJson(data)); 
      this.subjects_urgent_table = this.subjects_urgent.slice(0, 10);
     // console.log("Done loadng USER");
     // console.log(this.users);


    },
    error => {
    //  console.error('Error Loading User!');
    console.log(error);
    }
  ); }




clearSearchGrid() {
  this.grid.searchSettings.key = '';
  this.getJobSubjectsUrgentTableClient(this.brand_id);
}

searchGrid(name) {
  this.searchOptions = {  };
  this.grid.searchSettings.key = '';
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  const searchText: string = name;
  this.grid.search(searchText);

}

searchGridCol(name) {
// const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
// const searchText: string = name;
// this.grid.search(searchText);

// clear first
this.grid.searchSettings.key = '';
// now update the search uptions
this.searchOptions = { fields: ['note_type_name'], operator: 'contains', key: name, ignoreCase: true };
// now refresh the grid
this.grid.refresh();
}


searchGridColNextDate(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);
  
  // clear first
  this.grid.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = {
    fields: ['next_date_search'],
    operator: 'lessThan',
    key: this.toLegalGridSearchKey(name),
    ignoreCase: true,
  };
  // now refresh the grid
  this.grid.refresh();
  }



// NOT WORKING
searchGridMasters(name) {
this.grid.searchSettings.key = '';
// now update the search uptions
this.searchOptions = { 
  fields: ['assigned_to_subjects'], operator: 'equal', key: name
 
};
// now refresh the grid
this.grid.refresh();

}


getFormUserLevels() {
  this._demoService.getFormUserLevels().subscribe(
     data2 => { this.user_levels = data2;
      console.log(data2);
   },
     err => console.error(err),
     () => console.log('done loading User Levels')
   );
 }


 getBrandTypes() {
  this._demoService.getBrandBrandTypes().subscribe(
     data => { this.brand_types = data; },
     err => console.error(err),
     // () => console.log('done loading candidate for update')
   );
 }


  
// :: Reporting
getReportBrandsClientSearch(search_model) {
  this.brand_user_join_results = [];
  search_model.brand_type_id = 2;
  search_model.access_level = 9;
    this._demoService.getReportBrandsSearch(search_model).subscribe(
      data => { this.brand_search = data;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.brand_search_results = DataUtil.parse.parseJson(data); 
  // get the users as well and join the records together
  this.getReportUsersSearch(search_model);
  
  // now how to join two arrays of objects.
  // maybe pass results in to a new model.
  
  // Count items of brand search to loop through
  let  count_of_brand_items = Object.keys(this.brand_search).length;
  // now loop and push to join model
  for(let i=0;i < count_of_brand_items; i++) {
    let res = this.brand_search_results[i];
  
      // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
      this.brand_user_join_results.push({
        email_address: res.email,
        first_name: res.name,
        surname: res.surname,
        company_name: res.name,
        created: res.created,
              });
  
  } // end brands loop.
  
  this.brand_user_join_results = this.brand_user_join_results;
  
       this.grid.refresh();
      },
      error => {
      console.error('Error Loading !' + error.error);
      console.log(error);
      // return Observable.throw(error);
      }

    ); }




    getReportUsersSearch(search_model) {

      this._demoService.getReportUsersSearch(search_model).subscribe(
        data => { this.user_search = data;
          // pass so that the dates are correct in Sync
          // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
          this.user_search_results = DataUtil.parse.parseJson(data);
  // Count items of users search to loop through
  let  count_of_user_items = Object.keys(this.user_search).length;
  // now loop and push to join model
  for(let i=0;i < count_of_user_items; i++) {
    let res = this.user_search_results[i];
  
  
      // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
      this.brand_user_join_results.push({
        email_address: res.email_address,
        first_name: res.first_name,
        surname: res.surname,
        company_name: res.company_name,
        created_date: res.created_date,
              });
  
  
  } // end users loop.
  
  this.brand_user_join_results = this.brand_user_join_results;
  this.grid.refresh();
  
  
      //   this.grid.refresh();
       //  this.agent_grid.refresh();
        },
        error => {
        console.error('Error Loading !' + error.error);
        console.log(error);
        // return Observable.throw(error);
        }
      ); }
  
  


      getReportSubjectsUrgentSearchClient(search_model) {
        this.brand_user_join_results = [];
        this.subjects_urgent = [];
        this.grid.searchSettings.key = ''; // resets the grid filters and buttons
        
      //  search_model.brand_type_id = 2;
      //  search_model.access_level = 9;
        const normalizedSearchModel = this.normalizeLegalSearchModel(search_model);
        normalizedSearchModel.brand_report_id = this.brand_id; // so that only this client brands will show.
        
        this._demoService.getReportSubjectsUrgentSearchClient(normalizedSearchModel).subscribe(
            data => { this.brand_search = data;
              // pass so that the dates are correct in Sync
              // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
              this.brand_search_results = DataUtil.parse.parseJson(data); 
        // get the users as well and join the records together
     
        // Run this function and use the same json object and keep adding or removing to it if you wish.
        //    this.getReportUsersSearch(search_model);
        
        // now how to join two arrays of objects.
        // maybe pass results in to a new model.
        
        // Count items of brand search to loop through
                                        let  count_of_brand_items = Object.keys(this.brand_search).length;
                                        // now loop and push to join model
                                        for(let i=0;i < count_of_brand_items; i++) {
                                          let res = this.brand_search_results[i];
                                        
                                            // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
                                            this.brand_user_join_results.push({
                                              email_address: res.email,
                                              first_name: res.name,
                                              surname: res.surname,
                                              company_name: res.name,
                                              created: res.created,
                                                    });

                                this.subjects_urgent.push({
                                  // email_address: res.email,
                                  // first_name: res.name,
                                  // surname: res.surname,
                                  // company_name: res.name,
                                  // created: res.created,
                                  ...this.brand_search_results[i]
                                        });


                                        } // end brands loop.
                                        
                                        this.brand_user_join_results = this.brand_user_join_results;
                                        this.subjects_urgent = this.applyLegalGridDateFields(this.subjects_urgent);
                                        this.subjects_urgent = this.subjects_urgent;
        
             this.grid.refresh();
            },
            error => {
            console.error('Error Loading !' + error.error);
            console.log(error);
            // return Observable.throw(error);
            }
      
          ); }

          
              getReportSubjectsUrgentTimeframeSearchClient(search_model) {
        this.brand_user_join_results = [];
        this.subjects_urgent = [];
        this.grid.searchSettings.key = ''; // resets the grid filters and buttons
        
      //  search_model.brand_type_id = 2;
      //  search_model.access_level = 9;
        const normalizedSearchModel = this.normalizeLegalSearchModel(search_model);
        normalizedSearchModel.brand_report_id = this.brand_id; // so that only this client brands will show.

        this._demoService.getReportSubjectsUrgentTiemrameSearchClient(normalizedSearchModel).subscribe(
            data => { this.brand_search = data;
              // pass so that the dates are correct in Sync
              // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
              this.brand_search_results = DataUtil.parse.parseJson(data); 
        // get the users as well and join the records together
     
        // Run this function and use the same json object and keep adding or removing to it if you wish.
        //    this.getReportUsersSearch(search_model);
        
        // now how to join two arrays of objects.
        // maybe pass results in to a new model.
        
        // Count items of brand search to loop through
                                        let  count_of_brand_items = Object.keys(this.brand_search).length;
                                        // now loop and push to join model
                                        for(let i=0;i < count_of_brand_items; i++) {
                                          let res = this.brand_search_results[i];
                                        
                                            // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
                                            this.brand_user_join_results.push({
                                              email_address: res.email,
                                              first_name: res.name,
                                              surname: res.surname,
                                              company_name: res.name,
                                              created: res.created,
                                                    });

                                this.subjects_urgent.push({
                                  // email_address: res.email,
                                  // first_name: res.name,
                                  // surname: res.surname,
                                  // company_name: res.name,
                                  // created: res.created,
                                  ...this.brand_search_results[i]
                                        });


                                        } // end brands loop.
                                        
                                        this.brand_user_join_results = this.brand_user_join_results;
                                        this.subjects_urgent = this.applyLegalGridDateFields(this.subjects_urgent);
                                        this.subjects_urgent = this.subjects_urgent;
        
             this.grid.refresh();
            },
            error => {
            console.error('Error Loading !' + error.error);
            console.log(error);
            // return Observable.throw(error);
            }
      
          ); }

      
  
  addDays(days : number): Date{
  let futureDate = new Date();
  futureDate.setDate(futureDate.getDate() + days);
  return futureDate;
  }
  
  
  removeDays(days : number): Date{
  let futureDate = new Date();
  futureDate.setDate(futureDate.getDate() - days);
  return futureDate;
  }

  private setLegalGridDateFields(element: any): void {
    ['next_date', 'final_date', 'hearing_date', 'judgement_date', 'filing_date', 'instructions_date', 'aos_date']
      .forEach((field) => {
        element[`${field}_display`] = this.legalDate.format(element[field], 'DD/MM/YYYY h:mm a');
        element[`${field}_search`] = this.toLegalGridSearchKey(element[field]);
      });
  }

  private applyLegalGridDateFields(rows: any[]): any[] {
    if (!Array.isArray(rows)) {
      return rows;
    }

    rows.forEach((row) => this.setLegalGridDateFields(row));
    return rows;
  }

  private toLegalGridSearchKey(value: any): string {
    return this.legalDate.format(value, 'YYYY-MM-DD');
  }
  
  searchGridColNextDateToday(name, operator) {
    // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
    // const searchText: string = name;
    // this.grid.search(searchText);
    
    // clear first
    this.grid.searchSettings.key = '';
    // now update the search uptions // equal // Neq.
    this.searchOptions = {
      fields: ['next_date_search'],
      operator,
      key: this.toLegalGridSearchKey(name),
      ignoreCase: true,
    };
    // now refresh the grid
    this.grid.refresh();
    }

    searchGridColAnyDate( field, name, operator) {
      // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
      // const searchText: string = name;
      // this.grid.search(searchText);
      
      // clear first
      this.grid.searchSettings.key = '';
      // now update the search uptions // equal // Neq.
      this.searchOptions = {
        fields: [`${field}_search`],
        operator,
        key: this.toLegalGridSearchKey(name),
        ignoreCase: true,
      };
      // now refresh the grid
      this.grid.refresh();
      }



  refreshSearchGrid(){ // refresh the databutton
    this.mapJobTableLive();
    this.grid.refresh();
  };
  
  exportPDFClick(args: ClickEventArgs): void {
    if (args.item.id === 'Grid_pdfexport') { // 'Grid_pdfexport' -> Grid component id + _ + toolbar item name
        this.grid.pdfExport();
    }
  }
  
  
  getBrandBrandTypes(){
    this._demoService.getBrandBrandTypes().subscribe(
      data => { this.brand_types = data;
       let res = data[0];
     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }
  
  getUsers() {
    this._demoService.getUsers().subscribe(
      data => { this.users = data;
        this.usersPrimary = data;
       let res = data[0];
     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }





// New Grid functions Feb 2023

rowSelected(args: RowSelectEventArgs) {

  // console.log('selected data object: ' + JSON.stringify(args.data));
        //  // simply push the object/s seleceted to the  this.search_results array.
        //  if(!this.search_results){this.search_results = [];}; // set so is defined before push if empty
        //  this.search_results.push({
        //    ...args.data
        //  });
        // if (typeof args.data === 'object' && args.data !== null && args.data[0].id >= 0 ){
        //   console.log('We have a header object of data selected');
        // }

        //checks if single object
        if (typeof args.data === 'object' && args.data !== null && !args.data[0] ){
          if(!this.search_results){this.search_results = [];}; // detect if array exists.
          console.log('We have a single object of data selected');
            this.search_results.push({
            ...args.data
            });
        this.toastr.info( this.search_results.length + ' Clicked added to search results'); 

        }

        // if an a list of objects need to count and then loop through.
        if (typeof args.data === 'object' && args.data !== null && args.data[0] ){
          console.log('We have a OBJECT of object of data selected');
          const count_selected = this.grid.getSelectedRecords().length;
          console.log('count: ' + count_selected); // lenth is used for myob comparitor array
          const length = Object.keys(args.data).length
          console.log('length: ' + length);
        
          // now loop and insert individually
          if(!this.search_results){this.search_results = [];}; // detect if array exists.
          for(let i=0;i < length; i++) {
            this.search_results.push({
            ...args.data[i]
            });
            }
           this.toastr.info( this.search_results.length + ' Clicked added to search results');
          }



  const selectedrowindex: number[] = this.grid.getSelectedRowIndexes();  // Get the selected row indexes.
  // alert(selectedrowindex); // To alert the selected row indexes.
  const selectedrecords: object[] = this.grid.getSelectedRecords();  // Get the selected records.
  this.selectedrecords = this.grid.getSelectedRecords();


  }




        // we also need to create a row deselect event to remove from args
        rowDeSelected(args: RowSelectEventArgs) {

          
          const selectedrowindex: number[] = this.grid.getSelectedRowIndexes();  // Get the selected row indexes.
          // alert(selectedrowindex); // To alert the selected row indexes.
          const selectedrecords: object[] = this.grid.getSelectedRecords();  // Get the selected records.
          this.selectedrecords = this.grid.getSelectedRecords();

          // console.log('selected data object: ' + JSON.stringify(args.data));
                //  // simply push the object/s seleceted to the  this.search_results array.
              //    if(!this.search_results){this.search_results = [];}; // set so is defined before push if empty
              //  // clear the the search results. forst then re-add.
              //  this.search_results = [];
              //    this.search_results.push({
              //      ...args.data
              //    });
 
              let argData = args.data;
          if (typeof argData === 'object' && argData !== null && !argData[0] && argData !== '[]' ){
            console.log('We have a single object of data de-selected');
            let base_search_results = this.search_results
            
            // this.search_results = []; 
            // this.search_results.push({
            //   ...args.data
            //   });
            
 

              // leave items where not selected --- somehow add the ones that were already clicked before they all were removed.
              this.search_results =  this.search_results.filter(function (order) {
                // return true for salary greater than equals to 25000
                console.log('leaving IDs= ' + args.data['subject_number'] + ' != ' + order.subject_number);
                return order.subject_number != args.data['subject_number'];
              });
              this.toastr.warning( ' Subject Remved from the action list'); 
 

          // remove
          // filter and remove the selected ones from the object first.
              // let remove_unselected = this.comparitor_grid.getSelectedRowIndexes();
              // // let uniqueArray = this.search_results.filter((v,i,a)=>a.findIndex(t=>(t.id === remove_unselected))===i);
            
          }    


          // if an a list of objects need to count and then loop through.
          if (typeof args.data === 'object' && args.data !== null && args.data[0] ){
            console.log('We have a OBJECT of object of data DE-selected');
            const count_selected = this.grid.getSelectedRecords().length;
            console.log('count: ' + count_selected); // both count methods work.
            // const length = Object.keys(args.data).length
            // console.log('length: ' + length);
          
            // now loop and insert individually
       //     this.search_results = []; 
            for(let i=0;i < count_selected; i++) {
              // for(let i=0;i < count_selected; i++) { // made i 1 because was alwsays missing one
            //   this.search_results.push({
            //  ...args.data[i]
            //   });

              // leave items where not selected 
                  // this.search_results =  this.search_results.filter(function (order) {
                  // // return true for salary greater than equals to 25000
                  // console.log('leaving IDs= ' + args.data['i'].id + ' != ' + order.id);
                  // return order.id != args.data['id'];
                  // });
                  // this.search_results = this.search_results;

                               // leave items where not selected --- somehow add the ones that were already clicked before they all were removed.
              this.search_results =  this.search_results.filter(function (order) {
                // return true for salary greater than equals to 25000
                console.log('leaving IDs= ' + args.data[i]['subject_number'] + ' != ' + order.subject_number);
                return order.id != args.data[i]['subject_number'];
              });
             

              }

              this.toastr.warning( ' Subjects Remved from the action list'); 
          
            }


        
          }




    clearSearchResults(){
      this.search_results = [];
      // this.comparitor_array_A = [];
      // this.comparitor_array_A_FULL = [];
      // this.comparitor_array_B = [];
      // this.comparitor_array_B_FULL = [];
      this.toastr.info('Clearing All Comparitor FULL arrays complete.')
    }




    sortComparer(reference: string, comparer: string) { 
      // This will be triggered for comparing each value with the reference value 
      // This can be customized to compare the values as per your need and return the corresponding result 
    
      let r: number = +reference
      let c: number = +comparer
      
      if (r < c) { 
        // console.log('reference ' + reference)  
        // console.log('comparer ' + comparer)  
        return -1; 
          
      } 
      if (r > c) { 
        // console.log('reference gtr ' + reference)  
        // console.log('comparer grt' + comparer)  
          return 1; 
      } 
      //was 0
      return 0; 
    } 






}
